function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
export var CustomError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CustomError, Error1);
    var _super = _create_super(CustomError);
    function CustomError(message) {
        _class_call_check(this, CustomError);
        var _this;
        _this = _super.call(this, message);
        _this.name = _this.constructor.name;
        _this.message = message;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_assert_this_initialized(_this), _this.constructor);
        } else {
            _this.stack = new Error(message).stack;
        }
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_assert_this_initialized(_this), CustomError.prototype);
        return _this;
    }
    return CustomError;
}(_wrap_native_super(Error));
/**
 * Error class for backend errors
 */ export var BackendError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    _inherits(BackendError, CustomError);
    var _super = _create_super(BackendError);
    function BackendError(message) {
        var statusCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
        _class_call_check(this, BackendError);
        var _this;
        _this = _super.call(this, message);
        _define_property(_assert_this_initialized(_this), "statusCode", void 0);
        _this.statusCode = statusCode;
        Object.setPrototypeOf(_assert_this_initialized(_this), BackendError.prototype);
        return _this;
    }
    return BackendError;
}(CustomError);
export var PrivateEphemeralConfigError = /*#__PURE__*/ function(BackendError) {
    "use strict";
    _inherits(PrivateEphemeralConfigError, BackendError);
    var _super = _create_super(PrivateEphemeralConfigError);
    function PrivateEphemeralConfigError() {
        _class_call_check(this, PrivateEphemeralConfigError);
        var _this;
        var statusCode = 400;
        var message = 'If privacy is set to private-ephemeral, a TTL is required. None was set';
        _this = _super.call(this, message, statusCode);
        Object.setPrototypeOf(_assert_this_initialized(_this), PrivateEphemeralConfigError.prototype);
        return _this;
    }
    return PrivateEphemeralConfigError;
}(BackendError);
